import { useDeleteEmployeeWebPictureMutation, useUpdateEmployeeWebPictureMutation } from 'store/api/employeeWeb';

/**
 * Saves the website picture the web card holds, through its own endpoint: the employee update carries no picture,
 * so a save sends a changed one here first.
 */
export function useSaveWebPicture(employeeId: string) {
    const [updatePicture] = useUpdateEmployeeWebPictureMutation();
    const [deletePicture] = useDeleteEmployeeWebPictureMutation();
    return async (picture: string | null, storedPicture: string | null) => {
        if (picture === storedPicture) {
            return;
        }
        await (picture ? updatePicture({ employeeId, pictureBase64: picture }) : deletePicture(employeeId)).unwrap();
    };
}
